import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RIDERS_LIVE, {
      queryParams: payload
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch live riders',
        data: null,
      }
    }

    const liveRiders = raw.data?.data || []
    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: raw.data?.total || liveRiders.length,
        result: liveRiders,
      },
    }
  },
}
